var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view',{staticClass:"view",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
return [_c('transition',{attrs:{"name":"animation","enter-active-class":"animated fadeIn"}},[_c(Component,{tag:"component"})],1)]}}])}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }